import HeatingEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HeatingEnergy'
import HotwaterEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HotwaterEnergy'
import CookingEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/CookingEnergy'
import Surface from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/Surface'
import useAddress from '../../useAddress'
import { StyledTitle } from '@/containers/SubscriptionFormPageNew/Panel/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { PulseSectionKicker } from '../../styled-components'

const Consumption = () => {
  const { t, showConsumption } = useAddress()
  const isPulse = usePulseScope()
  const Title = isPulse ? PulseSectionKicker : StyledTitle

  if (!showConsumption) return null

  return (
    <>
      <Title id='ConsumptionSection'>{t('subscriptionForm:address_v2.consumption_title')}</Title>
      <HeatingEnergy />
      <HotwaterEnergy />
      <CookingEnergy />
      <Surface />
    </>
  )
}

export default Consumption
